import { render, staticRenderFns } from "./ModelsContainer.vue?vue&type=template&id=66e66cbf&scoped=true&"
import script from "./ModelsContainer.vue?vue&type=script&lang=js&"
export * from "./ModelsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModelsContainer.vue?vue&type=style&index=0&id=66e66cbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e66cbf",
  null
  
)

export default component.exports